import { createImportAsyncMethod } from '../importAsync';
export function initItem(settings, http) {
  return {
    importAsync: createImportAsyncMethod(settings, http)
  };
}